import { buildDatabaseSchema } from '@1inch-community/core/database';
import { lazyAppContext } from '@1inch-community/core/lazy';
import { TtlMapStorage, TTLStorage } from '@1inch-community/core/storage';
import { Subject } from 'rxjs';
export class TokenSchema {
    constructor() {
        this.context = lazyAppContext('TokenSchema');
        this.tokensTTL = new TTLStorage(buildTTLStorageName('tokens'), 6.048e8 // week,
        );
        this.balancesTTL = new TtlMapStorage(buildTTLStorageName('balances'), 12000);
        this.tokenPriceTTL = new TTLStorage(buildTTLStorageName('tokenPrice'), 12000);
        this.updateEmitters = {
            tokens: new Subject(),
            balances: new Subject(),
            tokenPrice: new Subject(),
            favoriteTokens: new Subject(),
        };
    }
    static { this.databaseVersion = 1; }
    static { this.databaseName = 'one-inch-token-v2'; }
    get tokens() {
        if (!this.database)
            throw new Error('token database not init');
        return this.database.tokens;
    }
    get balances() {
        if (!this.database)
            throw new Error('token database not init');
        return this.database.balances;
    }
    get tokenPrice() {
        if (!this.database)
            throw new Error('token database not init');
        return this.database.tokenPrice;
    }
    get crossChainTokensBinding() {
        if (!this.database)
            throw new Error('token database not init');
        return this.database.crossChainTokensBinding;
    }
    get favoriteTokens() {
        if (!this.database)
            throw new Error('token database not init');
        return this.database.favoriteTokens;
    }
    async init(context) {
        this.context.set(context);
        const [Dexie] = await Promise.all([
            import('dexie').then((m) => m.Dexie),
            this.tokensTTL.init(context),
            this.balancesTTL.init(context),
            this.tokenPriceTTL.init(context),
        ]);
        const db = new Dexie(TokenSchema.databaseName);
        db.version(TokenSchema.databaseVersion).stores({
            tokens: buildDatabaseSchema('&id', 'address', 'decimals', 'chainId', 'name', 'symbol', '*tags', 'eip2612', 'logoURL', 'priority'),
            balances: buildDatabaseSchema('&id', 'tokenRecordId', 'chainId', 'tokenAddress', 'walletAddress', 'amount'),
            tokenPrice: buildDatabaseSchema('&id', 'tokenRecordId', 'chainId', 'price'),
            crossChainTokensBinding: buildDatabaseSchema('&symbol', '*tokenRecordIds', '*tokenAddresses', '*tokenNames', 'supportedChainIds', 'priority'),
            favoriteTokens: buildDatabaseSchema('&id'),
        });
        this.database = db;
    }
    tokensIsExpired() {
        return this.tokensTTL.isExpired();
    }
    balancesIsExpired(walletAddress) {
        return this.balancesTTL.isExpired(walletAddress);
    }
    tokenPriceIsExpired() {
        return this.tokenPriceTTL.isExpired();
    }
    async balancesIsEmpty(walletAddress) {
        const count = await this.balances
            .where('walletAddress')
            .equals(walletAddress.toLowerCase())
            .count();
        return count === 0;
    }
    async tokenPriceIsEmpty() {
        const count = await this.tokenPrice.count();
        return count === 0;
    }
    updateTokensComplete() {
        this.tokensTTL.reset();
        this.updateEmitters.tokens.next(void 0);
    }
    updateBalancesComplete(walletAddress) {
        this.balancesTTL.reset(walletAddress);
        this.updateEmitters.balances.next(walletAddress);
    }
    updateTokenPriceComplete() {
        this.tokenPriceTTL.reset();
        this.updateEmitters.tokenPrice.next(void 0);
    }
    updateFavoriteTokensComplete() {
        this.updateEmitters.favoriteTokens.next(void 0);
    }
}
function buildTTLStorageName(prefix) {
    return `${TokenSchema.databaseName}:${TokenSchema.databaseVersion}:${prefix}`;
}
//# sourceMappingURL=token.schema.js.map